export default function CenterCameraIcon() {
	return (
		<svg
			width="34"
			height="34"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_13084_339)">
				<path
					d="M14.2285 14.8284L17.0569 12L19.8854 14.8284"
					stroke="black"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M16.1507 6.10919C15.2172 3.85144 13.7593 2.39853 12.1216 2.39993C9.30363 2.39853 7.02002 6.69707 7.02002 11.9992C7.02002 17.3014 9.30363 21.5999 12.1216 21.5999C14.8819 21.5992 17.1301 17.4749 17.22 12.3233"
					stroke="black"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M22.0164 12.3897C22.1667 9.73817 17.9905 7.42168 12.6905 7.21483C7.39046 7.00798 2.97301 8.98906 2.82414 11.6406C2.67901 14.238 6.68285 16.5144 11.8277 16.8"
					stroke="black"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeDasharray="3.6 3.6"
				/>
			</g>
			<defs>
				<clipPath id="clip0_13084_339">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}